import "./Solutions.css";
import Footer from "./Footer";
import prototypingImg from "../assets/prototyping.png";



export default function SolPrototyping() {
    return (
        <section id="sol-proto">
            {/* TOP SECTION */}
            <div className="lightweighting-wrapper-a">
                {/* LEFT CONTENT */}
                <div className="lightweighting-text-a">
                    <h3>Prototyping</h3>
                    <h3>
                        Prototype Development
                    </h3>

                    <p>
                        The prototype is the first physical part after the phase of digital and virtual development and offers the first real learning experience and feedback. SCL offers this important stage to our customers to support early fitment in part level, engine level or vehicle testing. 
                    </p>
                </div>
            </div>

            {/* FULL WIDTH IMAGE */}
            <div className="sol-full-image">
                <img src={prototypingImg} alt="Prototype Development" />
            </div>

            <div className="dmp-wrapper-a">
                <div className="dmp-card">
                    <div className="dmp-header">
                        🧪 <span>Design</span>
                    </div>

                    <div className="dmp-body">
                        <h4>Focus</h4>
                        <p>
                            SCL supports our customer in the design stage with feasibility analysis for casting, machining and assembly to generate a prototype design in shortest time.
                        </p>

                        <h4>Tools & Technologies</h4>
                        <ul>
                            <li>
                                CAD modelling with design space consideration – Creo
                            </li>
                            <li>
                                Design for manufacturing with Magmasoft simulation
                            </li>
                        </ul>

                        <h4>Customer Benefits</h4>
                        <ul>
                            <li>Shortened development time</li>
                            <li>Lightweight component contributes to higher fuel efficiency and lower CO2 footprint</li>
                            <li>One-stop-shop supplier partner for prototype and series</li>
                        </ul>
                    </div>
                </div>

                {/* CARD 2 */}
                <div className="dmp-card">
                    <div className="dmp-header">
                        🧱 <span>Material</span>
                    </div>

                    <div className="dmp-body">
                        <h4>Focus</h4>
                        <p>
                            Prototyping of aluminium sand castings through strategic supplier partnerships enables rapid validation of component design, manufacturability, and performance before full-scale production. 
                        </p>

                        <h4>Capabilities</h4>
                        <ul>
                            <li>
                                Alloy selection considering the prototype process and product specification and requirements
                            </li>
                            <li>Heat treatment capability of selected alloy is considered</li>
                            <li>Focus on sustainable, low-CO₂ aluminium routes</li>
                        </ul>

                        <h4>Customer Benefits</h4>
                        <ul>
                            <li>- Rapid validation of component design and performance before serial production</li>
                            <li>- Reduced development timelines through established supplier partnerships</li>
                            <li>- Minimal differences between prototype and final series</li>
                            <li>- Smoother transition from prototype to serial production</li>

                        </ul>
                    </div>
                </div>
            </div>

            <div className="dmp-wrapper-1">
                {/* CARD 3 */}
                <div className="dmp-card">
                    <div className="dmp-header">
                        🔧 <span>Process</span>
                    </div>

                    <div className="dmp-body">
                        <h4>Focus</h4>
                        <p>
                            Flexible but reliable casting, machining and assembly processes, suitable for small and midsize volumes. SCL also supports customers with coating, child part assembly, and other value addition processes.
                        </p>

                        <h4>Capabilities</h4>
                        <ul>
                            <li>
                                Experienced team due to execution of multiple prototype projects
                            </li>
                            <li>Robust supplier network ready to run on demand</li>
                        </ul>

                        <h4>Customer Benefits</h4>
                        <ul>
                            <li>
                                Experienced in a large variety of products to be executed in short time
                            </li>
                            <li>Flexible in change management</li>
                        </ul>
                    </div>
                </div>
            </div>

            <Footer />
        </section>
    );
}
